// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 第三方库引入
import { createApp } from 'vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'font-awesome/css/font-awesome.css';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';


// 自定义模块引入
import App from './App.vue';
import router from './router';


// 创建 Vue 3 应用实例
const app = createApp(App);

// 使用路由插件
app.use(router);
app.use(Viewer);

// 挂载应用到 DOM 元素
app.mount('#app');